<template>
  <section :class="ns.b()">
    <header :class="ns.e('header')">
      <div :class="ns.e('title-wrap')">
        <span :class="ns.e('accent')" />
        <h2 :class="ns.e('title')">
          <slot name="title">{{ title }}</slot>
        </h2>
        <span v-if="count !== undefined && count !== ''" :class="ns.e('count')">
          {{ count }}
        </span>
      </div>
      <p v-if="hint || $slots.hint" :class="ns.e('hint')">
        <slot name="hint">{{ hint }}</slot>
      </p>
    </header>
    <div :class="ns.e('body')">
      <slot />
    </div>
  </section>
</template>

<script lang="ts" setup>
import { useNamespace } from '@zoryn/hooks'
import type { DashboardSectionProps } from './dashboard'

defineOptions({
  name: 'ZDashboardSection',
})

withDefaults(defineProps<DashboardSectionProps>(), {
  title: '',
  hint: '',
  count: undefined,
})

const ns = useNamespace('dashboard-section')
</script>
